export default __webpack_public_path__ + "static/media/code2.ca34717d.png";